// extracted by mini-css-extract-plugin
export default {"headerMenu":"AppMenu_headerMenu__UTXVs","style":"AppMenu_style__xWln2"};